import { PacketPrint } from '../PacketPrint';

/** Full-screen print preview — no app chrome (mounted outside AppLayout). */
export function PacketPage() {
  return <PacketPrint />;
}
